import styled from 'styled-components';

export const Intro = styled.div`
  margin-bottom: 1.25rem;
`;

export const Eyebrow = styled.p`
  margin: 0 0 0.4rem;
  color: var(--color-accentDark);
  font-size: 0.74rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  margin: 0;
  color: var(--color-mainDark);
  font-size: clamp(1.75rem, 4vw, 2.35rem);
`;

export const Subtitle = styled.p`
  margin: 0.6rem 0 0;
  color: var(--color-textMuted);
  line-height: 1.6;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.15rem 1rem;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`;

export const SelectGroup = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.42rem;
  margin-bottom: 0.95rem;
`;

export const Label = styled.label`
  color: var(--color-mainDark);
  font-size: 0.82rem;
  font-weight: 800;
`;

export const Select = styled.select`
  width: 100%;
  min-height: 3.2rem;
  padding: 0.78rem 0.95rem;
  border: 1px solid var(--color-borderStrong);
  border-radius: 0.9rem;
  background: #fff;
  color: var(--color-text);
  font: inherit;

  &:focus {
    border-color: #000;
    box-shadow: 0 0 0 4px rgba(192, 163, 117, 0.2);
    outline: none;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 7rem;
  box-sizing: border-box;
  padding: 0.82rem 0.95rem;
  border: 1px solid var(--color-borderStrong);
  border-radius: 0.9rem;
  background: #fff;
  color: var(--color-text);
  font: inherit;
  font-size: 1rem;
  line-height: 1.55;
  resize: vertical;

  &:focus {
    border-color: #000;
    box-shadow: 0 0 0 4px rgba(192, 163, 117, 0.2);
    outline: none;
  }
`;

export const PasswordHint = styled.p`
  margin: -0.1rem 0 0.65rem;
  color: var(--color-textMuted);
  font-size: 0.76rem;
`;

export const DeleteButton = styled.button`
  min-height: 2.65rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: .55rem .85rem;
  border: 1px solid rgba(196,58,58,.35);
  border-radius: 999px;
  background: #fff;
  color: var(--color-errorRed);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 800;
  cursor: pointer;

  &:hover { background: rgba(196,58,58,.06); }
`;

export const ModalContent = styled.div`
  padding: 0.5rem;
  color: var(--color-text);

  h2 { margin: 0 0 0.6rem; }
  p { margin: 0 0 1.5rem; color: var(--color-textMuted); line-height: 1.6; }
`;

export const ModalActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.8rem;

  @media (max-width: 32rem) {
    flex-direction: column-reverse;
    button { width: 100%; }
  }
`;


export const SaveState = styled.div`
  display: grid;
  gap: .08rem;
  min-width: 0;
  color: var(--color-textMuted);
  font-size: .7rem;

  strong {
    color: ${({ $dirty, $saving }) => ($saving ? '#765209' : $dirty ? '#8a5b13' : '#17623a')};
    font-size: .72rem;
  }

  span { line-height: 1.35; }
`;
